module.exports = __webpack_public_path__ + "img/seniors.546e36e6.svg";